var PES = PES || {};
PES.StickySidebar = function () {
    var jqStickySideBar;

    function init(sideBarSelector, forceSticked) {
        jqStickySideBar = $(sideBarSelector);
        stickySideBarWidth = jqStickySideBar.width();

        jqStickySideBar.stickySidebar({
            topSpacing: 65,
            bottomSpacing: 0
        });

        if (forceSticked === true) {
            setSticked();
            $(window).scroll(setSticked);
        }
        $('.sidebar__mobile select').on("change", function () {
            $(".sidebar__toc a[href='#" + this.options[this.selectedIndex].classList[0] +"']")[0].click();
        });

        $(window).resize(update);
    }

    function setSticked() {
        var jqWrapperSticky = jqStickySideBar.find('.inner-wrapper-sticky');
        var jqStickyParent = jqStickySideBar.parent();

        if (jqStickyParent.isFullInViewport()) {
            jqWrapperSticky.addClass('top-sticked');
        } else {
            jqWrapperSticky.removeClass('top-sticked');
            update();
        }
    }

    function update() {
        jqStickySideBar.stickySidebar('updateSticky');
    }

    return {
        init: init,
        update: update
    };
}();